/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms.podpp

import io.kvision.redux.RAction
import pl.finn.forms.Zalacznik

enum class FormularzWidok {
    PUSTY,
    NOWY,
    EDYCJA
}

data class Formularz(
    val widok: FormularzWidok,
    val form: PodppForm? = null,
    val token: String? = null,
    val zalaczniki: List<Zalacznik>? = null,
    val bladZapisu: String? = null
)

sealed class FormularzAction : RAction {
    data class Nowy(val formData: PodppFormData) : FormularzAction()
    data class Edycja(val formData: PodppFormData) : FormularzAction()
    data class DodajZalacznik(val zalacznik: Zalacznik, val aktualnyForm: PodppForm) : FormularzAction()
    data class UsunZalacznik(val nazwa: String, val aktualnyForm: PodppForm) : FormularzAction()
    data class BladZapisu(val bladZapisu: String, val aktualnyForm: PodppForm) : FormularzAction()
}

fun formularzReducer(state: Formularz, action: FormularzAction): Formularz = when (action) {
    is FormularzAction.Nowy -> {
        Formularz(
          widok = FormularzWidok.NOWY,
          form = action.formData.form,
          token = action.formData.token,
          bladZapisu = null
        )
    }
    is FormularzAction.Edycja -> {
        Formularz(
          widok = FormularzWidok.EDYCJA,
          form = action.formData.form,
          token = action.formData.token,
          zalaczniki = action.formData.zalaczniki,
          bladZapisu = null
        )
    }
    is FormularzAction.DodajZalacznik -> {
        val noweZalaczniki = state.zalaczniki?.plus(action.zalacznik) ?: listOf(action.zalacznik)
        state.copy(zalaczniki = noweZalaczniki, form = action.aktualnyForm)
    }
    is FormularzAction.UsunZalacznik -> {
        val noweZalaczniki = state.zalaczniki?.filter { it.nazwa != action.nazwa }
        state.copy(zalaczniki = noweZalaczniki, form = action.aktualnyForm)
    }
    is FormularzAction.BladZapisu -> {
        state.copy(bladZapisu = action.bladZapisu, form = action.aktualnyForm)
    }
}
